module.exports = __webpack_public_path__ + "img/a2.ed77bd57.png";